/* tslint:disable */

declare var Object: any;
export interface ListSpvPathInterface {
  "id"?: number;
}

export class ListSpvPath implements ListSpvPathInterface {
  "id": number;
  constructor(data?: ListSpvPathInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ListSpvPath`.
   */
  public static getModelName() {
    return "ListSpvPath";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ListSpvPath for dynamic purposes.
  **/
  public static factory(data: ListSpvPathInterface): ListSpvPath{
    return new ListSpvPath(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ListSpvPath',
      plural: 'ListSpvPaths',
      path: 'ListSpvPaths',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ListSpvPath.ts